import classNames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  code: string;
  name: string;
  onClick: (e: any) => void;
}

export default function Airport({ code, name, onClick }: IProps) {
  return (
    <button
      type="button"
      aria-label="경로 변경"
      className={cx('Airport')}
      onClick={onClick}
    >
      <i className={cx('name')}>{name}</i>
      <b className={cx('code')}>{code}</b>
    </button>
  );
}
